var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1172 13.6001H4.28285C4.12663 13.6001 4 13.7267 4 13.8829V19.7173C4 19.8735 4.12663 20.0001 4.28285 20.0001H10.1172C10.2734 20.0001 10.4 19.8735 10.4 19.7173V13.8829C10.4 13.7267 10.2734 13.6001 10.1172 13.6001Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1172 4H4.28285C4.12663 4 4 4.12664 4 4.28285V10.1172C4 10.2734 4.12663 10.4 4.28285 10.4H10.1172C10.2734 10.4 10.4 10.2734 10.4 10.1172V4.28285C10.4 4.12664 10.2734 4 10.1172 4Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7187 13.6001H13.8844C13.7282 13.6001 13.6016 13.7267 13.6016 13.8829V19.7173C13.6016 19.8735 13.7282 20.0001 13.8844 20.0001H19.7187C19.8749 20.0001 20.0016 19.8735 20.0016 19.7173V13.8829C20.0016 13.7267 19.8749 13.6001 19.7187 13.6001Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7187 4H13.8844C13.7282 4 13.6016 4.12664 13.6016 4.28285V10.1172C13.6016 10.2734 13.7282 10.4 13.8844 10.4H19.7187C19.8749 10.4 20.0016 10.2734 20.0016 10.1172V4.28285C20.0016 4.12664 19.8749 4 19.7187 4Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.d6226bbd1a09c9ebab61e606254b21be.svg";
export { ForwardRef as ReactComponent };